import { render, staticRenderFns } from "./Yyjs.vue?vue&type=template&id=39e34ee8&"
import script from "./Yyjs.vue?vue&type=script&lang=js&"
export * from "./Yyjs.vue?vue&type=script&lang=js&"
import style0 from "./Yyjs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports